import styled from '../../../styled';
const LoadingSpinnerContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export default LoadingSpinnerContainer;
//# sourceMappingURL=LoadingSpinnerContainer.js.map